import {
  CircularProgress as ChakraCircularProgress,
  forwardRef,
} from '@chakra-ui/react';
import type { CircularProgressProps as ChakraCircularProgressProps } from '@chakra-ui/react';

export type CircularProgressProps = ChakraCircularProgressProps;

export const CircularProgress = forwardRef<ChakraCircularProgressProps, 'div'>(
  (
    {
      trackColor = 'page.plateLight',
      color = 'brand.secondary',
      fontFamily = 'default',
      fontWeight = 'default',
      children,
      ...restProps
    },
    ref,
  ) => {
    return (
      <ChakraCircularProgress
        ref={ref}
        trackColor={trackColor}
        color={color}
        fontFamily={fontFamily}
        fontWeight={fontWeight}
        {...restProps}
      >
        {children}
      </ChakraCircularProgress>
    );
  },
);

CircularProgress.displayName = 'CircularProgress';
